import React, { useEffect, useRef, useState } from 'react';
import {
  RichTextEditorComponent,
  Toolbar,
  Image,
  Link,
  HtmlEditor,
  QuickToolbar,
  Inject,
  Table
} from '@syncfusion/ej2-react-richtexteditor';
import { useSelector } from 'react-redux';
import { typeSupport } from '../Editor/utils';
import "./TinyMCEEditor.css"
const TinyMCEEditor = ({ setContentData, data, id, inline }) => {
  const editorRef = useRef(null);
  const first = useRef(true);
  const [localData, setLocalData] = useState('');
  const { direction, texts } = useSelector(state => state.translate);

  useEffect(() => {
    if (id) {
      first.current = true;
      setLocalData(data || '');
    }
  }, [id]);

  useEffect(() => {
    if (!first.current) {
      setContentData(localData);
    } else {
      first.current = false;
    }
  }, [localData]);



  const fontFamily = {
    default: 'Heebo',
    width: '50px',
    items: [
      { text: 'Heebo', value: 'Heebo' },
      { text: 'myFirstFont', value: 'myFirstFont' },
      { text: 'Andale Mono', value: 'andale mono,times' },
      { text: 'Arial', value: 'arial,helvetica,sans-serif' },
      { text: 'Arial Black', value: 'arial black,avant garde' },
      { text: 'Book Antiqua', value: 'book antiqua,palatino' },
      { text: 'Comic Sans MS', value: 'comic sans ms,sans-serif' },
      { text: 'Courier New', value: 'courier new,courier' },
      { text: 'Georgia', value: 'georgia,palatino' },
      { text: 'Helvetica', value: 'helvetica' },
      { text: 'Impact', value: 'impact,chicago' },
      { text: 'Symbol', value: 'symbol' },
      { text: 'Tahoma', value: 'tahoma,arial,helvetica,sans-serif' },
      { text: 'Terminal', value: 'terminal,monaco' },
      { text: 'Times New Roman', value: 'times new roman,times' },
      { text: 'Trebuchet MS', value: 'trebuchet ms,geneva' },
      { text: 'Verdana', value: 'verdana,geneva' },
      { text: 'Webdings', value: 'webdings' },
      { text: 'Wingdings', value: 'wingdings,zapf dingbats' }
    ]
  };

  const fontSize = {
    default: '14px',
    width: '40px',

    items: [
      { text: '8px', value: '8px' },
      { text: '9px', value: '9px' },
      { text: '10px', value: '10px' },
      { text: '11px', value: '11px' },
      { text: '12px', value: '12px' },
      { text: '14px', value: '14px' },
      { text: '18px', value: '18px' },
      { text: '20px', value: '20px' },
      { text: '22px', value: '22px' },
      { text: '24px', value: '24px' },
      { text: '30px', value: '30px' },
      { text: '36px', value: '36px' },
      { text: '48px', value: '48px' },
      { text: '60px', value: '60px' },
      { text: '72px', value: '72px' },
    ]
  };

  const toolbarSettings = {
    items: [
      "FontSize",
      "FontName",
      "Bold",
      "Italic",
      "Underline",
      "StrikeThrough",
      "SuperScript",
      "SubScript",
      "FontColor",
      "BackgroundColor",
      "LowerCase",
      "UpperCase",
      "Alignments",
      "OrderedList",
      "UnorderedList",
      "Indent",
      "Outdent",
      "CreateLink",
      "RemoveLink",
      "Image",
      "CreateTable",
      "Undo",
      "Redo",
      "ClearFormat",
      "SourceCode",
      "FullScreen",
      "Print"
    ].filter(Boolean), // 👈 מסנן null/undefined/false
  };

  const handleImageUpload = (args) => {
    const file = args.file;

    if (file && file.type.startsWith('image/')) {
      args.cancel = true; // ביטול ההעלאה המובנית

      const url = URL.createObjectURL(file); // יצירת blob url
      editorRef.current?.executeCommand('insertImage', { url });
    } else {
      args.cancel = true;
      alert(texts?.fileNotSupported || 'File type not supported');
    }
  };

  const handleImageSelected = (args) => {
    const file = args.event.target?.files?.[0];
    if (file && !typeSupport(file.type)) {
      args.cancel = true; // מונע העלאה מובנית
      alert(texts.fileNotSupported)
    }
  };


  return (
    <RichTextEditorComponent
      key={id}
      id={`richText-${id}`}
      enableAutoUrl={true} 
      // className={className}
      saveInterval={500}
      // tabIndex={"0"}
      aria-labelledby="labelRich"
      fontFamily={fontFamily}
      fontSize={fontSize}
      // placeholder={placeholder || texts.positionPaperPlaceHolder}
      ref={editorRef}
      toolbarSettings={toolbarSettings}
      value={localData !== undefined ? localData : ''}
      locale="he"
      pasteCleanupSettings={{ keepFormat: false, removeLineBreaks: true, plainText: true }}
      enableRtl={true}
      change={(e) => {
        if (e.action !== 'tab') {
          setLocalData(e.value)
        }
      }
      }

      insertImageSettings={{
        saveFormat: "Blob"
      }}
      imageSelected={handleImageSelected}
      quickToolbarSettings={{
        table: ['TableHeader', 'TableRows', 'TableColumns', 'Alignments', 'Delete', 'TableCellVerticalAlign', 'Styles']
      }}
    // created={onEditorCreated}
    // focus={handleFocus}
    >
      <Inject services={[Toolbar, Link, HtmlEditor, QuickToolbar, Image, Table]} />
    </RichTextEditorComponent>
  );
};

export default TinyMCEEditor;
